import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight, FileText, Building2, Wallet } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const services = [
  {
    icon: <FileText className="w-8 h-8" />,
    title: 'Government Subsidies',
    description: 'Expert guidance on state and central government incentive schemes for businesses and MSMEs.',
    link: '/services#subsidies'
  },
  {
    icon: <Building2 className="w-8 h-8" />,
    title: 'SME & Project Loans',
    description: 'Comprehensive financing solutions for new projects, business expansion, and working capital needs.',
    link: '/services#sme-loans'
  },
  {
    icon: <Wallet className="w-8 h-8" />,
    title: 'Retail Loans',
    description: 'Personal and business loans including home loans, LAP, and business financing from leading banks.',
    link: '/services#retail-loans'
  }
];

export const HomeServices = () => (
  <section className="py-24 bg-white" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mb-16"
      >
        <span className="inline-block px-4 py-2 bg-[#f1f5f9] rounded-full text-sm font-medium text-[#3b5998] mb-4">
          Our Services
        </span>
        <h2 className="font-heading text-3xl sm:text-4xl font-semibold text-[#0f172a] mb-4">
          Comprehensive Financial Solutions
        </h2>
        <p className="text-[#64748b] max-w-2xl mx-auto">
          From government subsidies to business loans, we offer tailored consultancy services 
          designed to accelerate your financial growth.
        </p>
      </motion.div>

      <div className="grid md:grid-cols-3 gap-8">
        {services.map((service, index) => (
          <motion.div
            key={service.title}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.15 }}
          >
            <Card className="service-card h-full border border-slate-100 hover:border-[#00bcd4]/30 bg-white">
              <CardContent className="p-8">
                <div className="w-14 h-14 rounded-xl bg-gradient-to-br from-[#3b5998] to-[#00bcd4] flex items-center justify-center text-white mb-6">
                  {service.icon}
                </div>
                <h3 className="font-heading text-xl font-semibold text-[#0f172a] mb-3">
                  {service.title}
                </h3>
                <p className="text-[#64748b] text-sm leading-relaxed mb-6">
                  {service.description}
                </p>
                <Link
                  to={service.link}
                  data-testid={`service-link-${index}`}
                  className="inline-flex items-center gap-2 text-[#3b5998] font-medium text-sm hover:text-[#00bcd4] transition-colors"
                >
                  Learn More
                  <ArrowRight size={16} />
                </Link>
              </CardContent>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
